import useDataTable from "hooks/useDataTable";
import { promoDiscountColumn } from "./shift-records-details-cash-non-cash-column";
import { promoDiscountMapper } from "./shift-records-details-cash-non-cash.mapper";
import { initialFilterState } from "modules/shift-records/shift-records-filter.state";
import locale from "localization/en";
import styles from "./shift-records-details-cash-and-non-cash.module.scss";
import { DataTableV2, Title } from "components/commons";
import { useMemo } from "react";

const ShiftDetailsPromoSummary = ({ shift }) => {
  const sortedPromos = useMemo(() => {
    const result = shift?.promos || [];

    return result.sort((a, b) => {
      const aIsNumber = typeof a.discount === "number";
      const bIsNumber = typeof b.discount === "number";

      if (aIsNumber && bIsNumber) return a.discount - b.discount;
      if (!aIsNumber && !bIsNumber) return a.discount.localeCompare(b.discount);
      return aIsNumber ? -1 : 1;
    });
    // .reduce((acc, item) => {
    //   const existing = acc.find((x) => x.type === item.type);

    //   if (existing) {
    //     existing.totalQuantities += item.totalQuantities;
    //     existing.totalTransactions += item.totalTransactions;
    //   } else {
    //     acc.push({ ...item });
    //   }

    //   return acc;
    // }, []);
  }, [shift?.promos]);

  const { table } = useDataTable({
    value: sortedPromos || [],
    filter: { initialState: initialFilterState(), mapper: (data) => data },
    table: {
      key: "promos",
      mapper: (val) => promoDiscountMapper({ val, shiftId: shift?.shift?.shiftId }),
      columns: promoDiscountColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.promoSummary}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsPromoSummary;
